import { useEffect } from 'react';

import { FormattedDate, FormattedTime, useIntl } from 'react-intl';
import { useSuperState } from 'hooks';
import { useApp } from 'app';

export const WelcomeBanner = props => {

    const [state, setState] = useSuperState({
        currentTime: new Date()
    });
    const { currentTime } = state;

    const { currentUser } = useApp();
    const { formatMessage } = useIntl();

    useEffect(() => {

        const ticker = setInterval(() => {

            setState({ currentTime: new Date() });

        }, 60000);

        return () => clearInterval(ticker);

    }, []);

    return (
        <>
            <div className={'page-header d-flex flex-column flex-md-row gap-2 justify-content-between align-items-baseline'}>
                <h1 className={'m-0 text-strong'}>
                    {`${formatMessage({ id: 'welcome.2cb04305', defaultMessage: 'Welcome' })} ${currentUser.fullName}`}
                </h1>
                <span className="text-muted d-flex align-items-center gap-1">

                    <span>
                        <FormattedTime
                            hour="numeric"
                            minute="2-digit"
                            value={currentTime}
                        />
                    </span>

                    <span>
                        <FormattedDate
                            day="numeric"
                            month="long"
                            value={currentTime}
                            weekday="long"
                            year="numeric"
                        />
                    </span>

                </span>
            </div>
            <hr/>
        </>

    );

};